import { get, post, put, del } from '@api/request';

export async function fetchOwnerAgentExportLog(
  { exportService },
  authenticationToken,
) {
  let url = `${exportService}/export/owneragentexport`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteOwnerAgentExportLog(
  { exportService },
  authenticationToken,
  { logID },
) {
  let url = `${exportService}/export/owneragentexport/${logID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function ownerAgentExportLogLaunch(
  { exportService },
  authenticationToken,
  { payload },
) {
  let url = `${exportService}/export/owneragentexport`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const downloadFile = async (
  { appraisalService },
  authenticationToken,
  { id, s3Id },
) => {
  const url = `${appraisalService}/appraisal/exportowneragent/${id}/file`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const downloadReportFile = async (
  { appraisalService },
  authenticationToken,
  { id, s3Id },
) => {
  const url = `${appraisalService}/appraisal/exportowneragent/${id}/reportfile`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const downloadS3File = async (
  { exportService },
  authenticationToken,
  { s3Id },
) => {
  const url = `${exportService}/export/file/${s3Id}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const downloadFileWithURL = async (
  { exportService },
  authenticationToken,
  { s3Id, newWindow = false },
) => {
  const url = `${exportService}/export/fileurl/${s3Id}`;
  const { body } = await get(authenticationToken, url);

  const anchor = document.createElement('a');
  anchor.style.display = 'none';
  document.body.appendChild(anchor);

  const response = await fetch(body);
  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);

  anchor.href = objectUrl;
  anchor.download = s3Id;
  if (newWindow) {
    anchor.target = '_blank';
  }
  anchor.click();

  window.URL.revokeObjectURL(objectUrl);
  document.body.removeChild(anchor);

  return body;
};

export const downloadS3FileJSON = async (
  { exportService },
  authenticationToken,
  { s3Id },
) => {
  const url = `${exportService}/export/file/${s3Id}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchAppraisalExport(
  { exportService },
  authenticationToken,
) {
  let url = `${exportService}/export/appraisalexport`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalExportLog(
  { exportService },
  authenticationToken,
  { logID },
) {
  let url = `${exportService}/export/appraisalexport/log/${logID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalExportJSON(
  { exportService },
  authenticationToken,
  { page = 1, pageSize = 50 } = {},
) {
  let url = `${exportService}/export/protax/logs?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalExportJSONLog(
  { exportService },
  authenticationToken,
  { logID },
) {
  let url = `${exportService}/export/protax/log/${logID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalExportLogErrorSummary(
  { exportService },
  authenticationToken,
  { logID },
) {
  let url = `${exportService}/export/appraisalexport/log/${logID}/validationerrors/summary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalExportLogErrorDetail(
  { exportService },
  authenticationToken,
  { logID, validationType, category },
) {
  let url = `${exportService}/export/appraisalexport/log/${logID}/validationerrors/${validationType}/${category}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRollCorrections(
  { appraisalService },
  authenticationToken,
  { pYear },
) {
  let url = `${appraisalService}/appraisal/year/${pYear}/rollcorrections`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function exportAppraisal(
  { exportService },
  authenticationToken,
  payload,
) {
  let url = `${exportService}/export/appraisalexport`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAppraisalBetaExportList(
  { exportService },
  authenticationToken,
  { pageSize = 50, page = 0 },
) {
  let url = `${exportService}/export/runs?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getAppraisalBetaExportRun(
  { exportService },
  authenticationToken,
  { exportRunID },
) {
  let url = `${exportService}/export/run/${exportRunID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalBetaRunLog(
  { exportService },
  authenticationToken,
  { exportRunID },
) {
  let url = `${exportService}/export/run/${exportRunID}/log`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createExportAppraisalBeta(
  { exportService },
  authenticationToken,
  payload,
) {
  let url = `${exportService}/export/runs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function validateExportQuery(
  { exportService },
  authenticationToken,
  payload,
) {
  let url = `${exportService}/export/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function setExportAppraisalParam(
  { exportService },
  authenticationToken,
  { exportRunID, payload },
) {
  let url = `${exportService}/export/run/${exportRunID}/process/appraisal/params`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function startExportProcessPreData(
  { exportService },
  authenticationToken,
  { exportRunID, payload = {} },
) {
  let url = `${exportService}/export/run/${exportRunID}/process/prepdata`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function startExportProcessExportData(
  { exportService },
  authenticationToken,
  { exportRunID, payload = {} },
) {
  let url = `${exportService}/export/run/${exportRunID}/process/exportdata`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const downloadExportFile = async (
  { exportService },
  authenticationToken,
  { s3Id },
) => {
  const url = `${exportService}/export/file/true prodigy/${s3Id}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const downloadPresignedExportFile = async (
  { exportService },
  authenticationToken,
  { s3Id },
) => {
  const url = `${exportService}/export/file/${encodeURIComponent(s3Id)}`;
  console.log(url);

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function exportAppraisalJSON(
  { exportService },
  authenticationToken,
  payload,
) {
  let url = `${exportService}/export/protax`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function validateQuery(
  { exportService },
  authenticationToken,
  payload,
) {
  let url = `${exportService}/export/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function validateQueryJSON(
  { exportService },
  authenticationToken,
  payload,
) {
  let url = `${exportService}/export/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPTD({ ptdService }, authenticationToken) {
  let url = `${ptdService}/ptd/ptdruns`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSinglePTD(
  { ptdService },
  authenticationToken,
  { ptdRunID },
) {
  let url = `${ptdService}/ptd/${ptdRunID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function captureTotals(
  { ptdService },
  authenticationToken,
  { ptdRunID },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/capturetotals`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchValidationErrorSummary(
  { ptdService },
  authenticationToken,
  { ptdRunID, validationType },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/validationerrors/${validationType}/summary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchValidationErrorDetail(
  { ptdService },
  authenticationToken,
  { ptdRunID, validationType, category, page = 1, pageSize = 50 },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/validationerrors/${validationType}/${category}?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function preValidate(
  { ptdService },
  authenticationToken,
  { ptdRunID },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/prevalidate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function generatePTDRun(
  { ptdService },
  authenticationToken,
  { ptdRunID },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/createdata`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function postValidate(
  { ptdService },
  authenticationToken,
  { ptdRunID },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/postvalidate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchErrorSummary(
  { ptdService },
  authenticationToken,
  { ptdRunID },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/errorsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchErrorDetail(
  { ptdService },
  authenticationToken,
  { ptdErrorID },
) {
  let url = `${ptdService}/ptd/errors/${ptdErrorID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function exportEarsRun(
  { ptdService },
  authenticationToken,
  { ptdRunID },
) {
  let url = `${ptdService}/ptd/${ptdRunID}/export`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export const downloadEars = async (
  { ptdService },
  authenticationToken,
  { ptdRunID, s3ID },
) => {
  const url = `${ptdService}/ptd/${ptdRunID}/export/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function createEars({ ptdService }, authenticationToken, payload) {
  let url = `${ptdService}/ptd/ptdruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyTypes(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/codes?type=Property&name=Property%20Type`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchExportFormats(
  { exportService },
  authenticationToken,
) {
  let url = `${exportService}/export/appraisalexport/formats`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBppRenditionsExports(
  { exportService },
  authenticationToken,
  { pageSize = 50, page = 0 },
) {
  let url = `${exportService}/export/bpprenditions?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBppRenditionsExport(
  { exportService },
  authenticationToken,
  { exportRunID },
) {
  let url = `${exportService}/export/bpprendition/${exportRunID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createBppRenditionExport(
  { exportService },
  authenticationToken,
  payload,
) {
  let url = `${exportService}/export/bpprenditions`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyFormOptionsEvents(
  { eventService },
  authenticationToken,
) {
  const url = `${eventService}/events/peventforms?dataObject=property`;
  const { body } = await get(authenticationToken, url);
  return body;
}
